import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import { pageSeoConfig } from "@/lib/seo";
import { usePageSeo } from "@/hooks/usePageSeo";
import JsonLd from "@/components/JsonLd";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import Benefits from "@/components/Benefits";
import Pricing from "@/components/Pricing";
import FAQ from "@/components/FAQ";
import Subscribe from "@/components/Subscribe";
import Footer from "@/components/Footer";
import AISection from "@/components/AISection";

const Index = () => {
  usePageSeo(pageSeoConfig["/"]);

  // Enable smooth scrolling for anchor links
  useEffect(() => {
    // Smooth scrolling for anchor links
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a');
      
      if (!anchor) return;
      
      const href = anchor.getAttribute('href');
      
      if (href && href.startsWith('#') && href.length > 1) {
        e.preventDefault();
        const targetId = href.slice(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    };

    // Global parallax effect for sections
    const handleParallax = () => {
      const parallaxSections = document.querySelectorAll('.parallax-container');
      const scrollPosition = window.scrollY;

      parallaxSections.forEach((section) => {
        const offset = (section as HTMLElement).offsetTop;
        const height = (section as HTMLElement).offsetHeight;
        
        // Only apply effects when the section is visible
        if (scrollPosition + window.innerHeight >= offset && 
            scrollPosition <= offset + height) {
          
          // Apply subtle parallax to section background
          const yPosition = (scrollPosition - offset) * 0.1;
          (section as HTMLElement).style.backgroundPositionY = `${yPosition}px`;
        }
      });
    };

    document.addEventListener('click', handleAnchorClick);
    window.addEventListener('scroll', handleParallax);
    
    return () => {
      document.removeEventListener('click', handleAnchorClick);
      window.removeEventListener('scroll', handleParallax);
    };
  }, []);
  
  return (
    <div className="min-h-screen">
      <JsonLd />
      <Navbar />
      <main>
        <Hero />
        <AISection />
        <Features />
        <Benefits />
        <Pricing />
        <FAQ />
        <Subscribe />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
